export default {
    anonymous: {
        heading: 'Listed as',
        label: 'Anonymous',
        helperListed: 'Your name and photo appear in the rankings.',
        helperAnonymous:
            'Shown as “Anonymous”. You can switch back to your name through the 5th of this month.',
        helperLockedUntilNextMonth:
            'Shown as “Anonymous” until the 1st of next month. Opting back in is only allowed on the 1st through the 5th of each month.',
        helperLockedByAdmin:
            'This setting is locked for your account. Contact support to change it.',
        saving: 'Saving…',
        confirmTitle: 'List yourself as Anonymous?',
        confirmIntro:
            "Starting now, your name is replaced with “Anonymous” in this month's rankings and in the archive.",
        confirmHalfPrizes: 'Prizes are paid at half value.',
        confirmNoFirstPrize:
            "You cannot win the #1 prize, because the winner's photo can't be shown.",
        confirmOptInWindow:
            'You can switch back to your name only on the 1st-5th of a month.',
        confirmUndoWindow:
            'If you continue, you can undo this through the 5th of this month.',
        confirmNoUndo:
            'If you continue, you stay Anonymous until the 1st of next month.',
        confirm: 'List me as Anonymous',
        cancel: 'Keep my name',
        errorAfterFifth:
            'Unable to change this option after the 5th day of the month.',
        errorSaveFailed: 'Unable to change this option right now.',
        errorRefreshFailed:
            'Your setting was saved, but the rankings could not be reloaded. Refresh the page to see the change.',
    },
    nav: {
        topTwenty: 'Current Top 20',
        allRanks: "This Month's Top 1000",
        previous: "Previous Month's Standings",
        search: 'Search',
    },
    summary: {
        yourRank: 'Your rank',
        bestThisYear: 'Best this year:',
        history: 'Your Miss MyFreeCams history',
        notAvailable: 'N/A',
        notRanked: 'Not ranked',
        inProgress: 'This month is not finished yet',
        legendFirst: '#1',
        legendTopThree: '#2-3',
        legendTopHundred: 'Top 100',
        legendRanked: 'Ranked',
        legendCurrent: 'This month (in progress)',
    },
}
